import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ShToastModule } from '@stylehaven/components';
import { ToastsComponent } from './components/toasts/toasts.component';
import { ToastHelper } from './service/toast.helper';

@NgModule({
    imports: [CommonModule, ShToastModule],
    providers: [ToastHelper],
    declarations: [ToastsComponent],
    exports: [ToastsComponent]
})
export class SharedToastModule {}
export * from './service/toast.service';
